import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { AuthProvider } from "@/context/AuthContext";
import { RefreshProvider } from "@/context/RefreshContext";
import ProtectedRoute from "@/components/ProtectedRoute";
import Layout from "@/components/Layout";
import Login from "@/pages/Login";
import Dashboard from "@/pages/Dashboard";
import Informationen from "@/pages/Informationen";
import Appellthemen from "@/pages/Appellthemen";
import Fehlerliste from "@/pages/Fehlerliste";
import Inhaftierung from "@/pages/Inhaftierung";
import Haftrechner from "@/pages/Haftrechner";
import Langzeithaeftlinge from "@/pages/Langzeithaeftlinge";
import Einsaetze from "@/pages/Einsaetze";
import ChainGangs from "@/pages/ChainGangs";
import Parole from "@/pages/Parole";
import ParoleLog from "@/pages/ParoleLog";
import Officers from "@/pages/Officers";
import Verbrecherregister from "@/pages/Verbrecherregister";
import ExterneDokumente from "@/pages/ExterneDokumente";
import Lagerbestand from "@/pages/Lagerbestand";
import LiveKarte from "@/pages/LiveKarte";
import Administration from "@/pages/Administration";
import Archiv from "@/pages/Archiv";
import Gefaengnisordnung from "@/pages/Gefaengnisordnung";
import PublicGefaengnisordnung from "@/pages/PublicGefaengnisordnung";
import { Toaster } from "@/components/ui/sonner";

function App() {
  return (
    <div className="App">
      <AuthProvider>
        <RefreshProvider>
        <BrowserRouter>
          <Routes>
            <Route path="/login" element={<Login />} />
            <Route path="/public/gefaengnisordnung" element={<PublicGefaengnisordnung />} />
            <Route
              element={
                <ProtectedRoute>
                  <Layout />
                </ProtectedRoute>
              }
            >
              <Route path="/" element={<Informationen />} />
              <Route path="/statistik" element={<Dashboard />} />
              <Route path="/informationen" element={<Informationen />} />
              <Route path="/appellthemen" element={<Appellthemen />} />
              <Route path="/fehlerliste" element={<Fehlerliste />} />
              <Route path="/inhaftierung" element={<Inhaftierung />} />
              <Route path="/haftrechner" element={<Haftrechner />} />
              <Route path="/langzeithaeftlinge" element={<Langzeithaeftlinge />} />
              <Route path="/einsaetze" element={<Einsaetze />} />
              <Route path="/chaingangs" element={<ChainGangs />} />
              <Route path="/parole" element={<Parole />} />
              <Route path="/parole-log" element={<ParoleLog />} />
              <Route path="/officer" element={<Officers />} />
              <Route path="/verbrecherregister" element={<Verbrecherregister />} />
              <Route path="/externe-dokumente" element={<ExterneDokumente />} />
              <Route path="/gefaengnisordnung" element={<Gefaengnisordnung />} />
              <Route path="/lagerbestand" element={<Lagerbestand />} />
              <Route path="/live-karte" element={<LiveKarte />} />
              <Route path="/administration" element={<Administration />} />
              <Route path="/archiv" element={<Archiv />} />
            </Route>
          </Routes>
        </BrowserRouter>
        </RefreshProvider>
        <Toaster position="top-right" theme="dark" richColors />
      </AuthProvider>
    </div>
  );
}

export default App;
